define((require) => {
    "use strict";

    var Marionette  = require("marionette"),
        _           = require("underscore"),
        SceneEditor = require("ui/editor/SceneEditor");


    /**
     * Handlers zooming logic for experiences editor
     */
    return Marionette.Controller.extend({

        // Experiences editor
        _editor: null,

        // editor view model
        _viewModel: null,

        _zoomModel: null,

        _focusPoint: null,

        initialize: function(experiencesEditor) {
            this._editor = experiencesEditor;

            this.listenTo(this._editor, {
                "render": this._onRender
            });
        },

        // On experiencesEditor render event
        _onRender: function() {
            this._viewModel = this._editor.viewScope.viewModel;

            this._zoomModel = this._viewModel.get("zoomModel");

            this._editor.stickit(this._zoomModel, this.zoomBinding);
            this._updateZoomScale(null, this._zoomModel.get("scale"));

            this.stopListening(this._zoomModel, "change:scale");
            this.listenTo(this._zoomModel, "change:scale", this._updateZoomScale);

            // This custom event is fired from jquery tinyscrollbar, where it normalizes wheeldelta value
            this._editor.ui.scrollTarget.on("scrollToZoom", this._scrollToZoom.bind(this));
        },

        _updateZoomScale: function(viewModel, scale) {
            var prevScale = this._zoomModel.previous("scale"),
                scaled    = scale === 1 ? "" : "scaled";

            this._editor.ui.scrollTarget
                .removeClass("scaled scale-" + this._toString(prevScale))
                .addClass(scaled + " scale-" + this._toString(scale)); // add class so we can apply counter scale no-scale elements
        },

        _toString: function(val) {
            return val.toString().replace(/\./, "");
        },

        updateScrollbar: function() {
            var prevScale = this._zoomModel.previous("scale"),
                scale  = this._zoomModel.get("scale"),
                factor = (prevScale - scale) / prevScale;

            if (this._focusPoint) {
                this._editor.scrollbars.x.scrollTo("offset", this._focusPoint.x * factor, true, false);
                this._editor.scrollbars.y.scrollTo("offset", this._focusPoint.y * factor, true, false);
            }
        },

        // Compute current focusing point. If widgets selected, return the center of the widget,
        // else fallback to scene center, again fallbacks to the viewport center.
        setFocusPoint: function() {
            var selected    = this._viewModel.selection.get("widgets"),
                sceneIndex  = this._viewModel.getCurrentSceneIndex(),
                scale       = this._zoomModel.get("scale"),

                margin      = SceneEditor.SCENE_MARGIN * scale,
                sceneWidth  = this._editor.activeExperience.get("width") * scale,
                sceneHeight = this._editor.activeExperience.get("height") * scale,

                // The current scene relative to the scroll target container
                sceneLeft   = sceneWidth * sceneIndex + margin * (2 * sceneIndex + 1),
                sceneTop    = margin,

                x = 0,
                y = 0;

            if (selected.length === 1) {
                // Focus on widget  TODO: what about multiple selection
                var bounds = selected[0].getBoundingBox();
                x = sceneLeft + (bounds.x + bounds.width / 2) * scale;
                y = sceneTop + (bounds.y + bounds.height / 2) * scale;
            } else if (selected.length > 1) {
                var boundPoints = null,
                    self  = this,
                    axisX = [],
                    axisY = [];

                _.each(selected, (widget) => {
                    boundPoints = self.getBounds(widget);
                    axisX.push(boundPoints.left * scale, boundPoints.right * scale);
                    axisY.push(boundPoints.top * scale, boundPoints.bottom * scale);
                });

                x = sceneLeft + _.min(axisX) + (_.max(axisX) - _.min(axisX)) / 2;
                y = sceneTop + _.min(axisY) + (_.max(axisY) - _.min(axisY)) / 2;
            } else {
                // Focus on scene
                x = sceneLeft + sceneWidth / 2;
                y = sceneTop + sceneHeight / 2;
            }

            var ui        = this._editor.ui,
                viewportW = ui.viewport.outerWidth(),
                viewportH = ui.viewport.outerHeight(),
                overviewPosition = ui.overview.position(),
                overviewTop  = Math.abs(overviewPosition.top),
                overviewLeft = Math.abs(overviewPosition.left);

            // Check if the focusing point(x, y) computed above is within the viewport
            // If not, we fallback to the center of viewpoint
            if (overviewLeft > x || x > overviewLeft + viewportW || overviewTop > y || y > overviewTop +  viewportH) {
                // Focus on viewport
                x = overviewLeft + viewportW / 2;
                y = overviewTop + viewportH / 2;
            }

            this._focusPoint = {x: x, y: y};
        },

        getBounds: function(widget) {
            var bounds = widget.getBoundingBox();

            return {
                left: bounds.x,
                right: bounds.x + bounds.width,
                top: bounds.y,
                bottom: bounds.y + bounds.height
            };
        },

        _scrollToZoom: function(e, wheelEvent) {
            var deltaSpeed;

            // Cross browser and OS nonsense
            if (wheelEvent.deltaY !== undefined) {
                deltaSpeed = wheelEvent.deltaY;
                if (deltaSpeed === 0) {
                    deltaSpeed = wheelEvent.deltaX;
                }
            } else if (wheelEvent.wheelDelta !== undefined) {
                deltaSpeed = wheelEvent.wheelDeltaY;
            } else if (wheelEvent.detail) {
                deltaSpeed = wheelEvent.detail;
            }

            this._throttledZoom(deltaSpeed > 0 ? "In" : "Out");
        },

        _throttledZoom: _.throttle(function(direction) {
            this["zoom" + direction]();
        }, 40, {trailing: false})
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/ExperiencesEditorZoom.js